import { Vue } from "vue-class-component";

export default class Report extends Vue {
}

